
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/badges",
      function () {
        return require("private-next-pages/dashboard/badges.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/badges"])
      });
    }
  